import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import SkipLink from "../components/SkipLink";

export default function AppLayout() {
  return (
    <div className="App">
      <SkipLink />
      <Navbar />
      <main className="main-content" id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
